import { render, staticRenderFns } from "./car-insurance-personal-form.html?vue&type=template&id=228ae036&scoped=true&"
import script from "./car-insurance-personal-form.js?vue&type=script&lang=js&"
export * from "./car-insurance-personal-form.js?vue&type=script&lang=js&"
import style0 from "./car-insurance-personal-form.scss?vue&type=style&index=0&id=228ae036&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ae036",
  null
  
)

export default component.exports